<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy" @click.prevent="autoChange">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div v-if="inputGroupBy == 'monthly'" class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-month-picker v-model="inputFrom" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                                    </base-input>
                                </div>
        
                                <div class="col-md-7">
                                    <base-input alternative="" label="To"><br>
                                        <a-month-picker v-model="inputTo" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                                    </base-input>
                                </div>
                            </div>
                            <div v-else class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row" v-if="site_type == 'ho'">
                                <div class="col-md-7">
                                    <base-input label="Location">
                                        <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" changeOnSelect/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" size="large" v-model="inputSortBy" @click.prevent="sortChange">>
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                    </button>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input type="number" min="0" v-if="inputSortBy == 'total_amount' || inputSortBy == 'qty'" placeholder="" label="Show Top" v-model="inputShowTop" />
                                    <base-input type="number" min="0" v-else placeholder="" label="Show Top" v-model="inputShowTop" disabled/>
                                </div>
                            </div>
        
                            <base-checkbox class="mb-3" v-model="isShowDetail" :disabled="inputGroupBy == ''">
                                Show Details
                            </base-checkbox>
                            <div class="row">
                                <div class="col-md-2">
                                    <base-checkbox class="mb-3" v-model="isSeparateSite">
                                        Separate per site
                                    </base-checkbox>
                                </div>
                                <div class="col-md-2">
                                    <base-checkbox class="mb-3" v-model="isShowTotalAmountWithoutTax">
                                        Show Total Amount w/o Tax
                                    </base-checkbox>
                                </div>
                            </div>
        
        
                            <div class="row">
                                <div class="col-md-7">
                                    <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                        {{toggleLabel}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';

    import {
        mapState,
        mapActions
    } from 'vuex'
import { getReportDescription } from '../../utilities';

    var component_x;

    export default {
        components: {
            AdvanceFilter,VueJsonToCsv
        },
        data() {
            return {
                spinning: false,
                accessCostPriceRights: [],
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: '',
                groupOptions: [
                    {key: '', value: 'No Grouping'},
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'supplier_type_id', value: 'Supplier Type, Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'division_id', value: 'Division'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'},
                    {key: 'customer_id', value: 'Customer'},
                    {key: 'customer_type_id', value: 'Customer Type'},
                    {key: 'daily', value: 'Daily Returns'},
                    {key: 'monthly', value: 'Monthly Returns'}
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputSortBy: 'id',
                sortOptions: [
                    {key: 'id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'total_amount', value: 'Total Amount'},
                    {key: 'qty', value: 'Total Quantity'}
                ],
                isSeparateSite: true,
                isShowDetail: true,
                inputFrom: moment().startOf('month'),
                inputTo: moment().endOf('month'),
                monthFormat: 'MM/YYYY',
                birSalesReports: [],

                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,

                inputLocation: [],
                locationOptions: [],
                
                currDate: moment().format("L_LT").split(":").join(";"),
                showSortInfo: 'asc',
                inputShowTop: 0,
                JsonData: [],
                isShowTotalAmountWithoutTax: false,
                reportDescription: ''
            }
        },
        mounted: async function () {
            component_x = this;

            this.accessCostPriceRights = this.$attrs.access_costprice_rights || []

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
            this.reportDescription = await getReportDescription(this.currentProfile);
            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            if(component_x.categoriesOptions.length == 0){
                var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                component_x.updateCategoriesOptions(options)
            }
        },
        computed: {
            ...mapState(['currentProfile','endPoint', 'categoriesOptions']),
        },
        watch: {
            inputLocation: {
                handler: 'handleInputLocationChange',
                deep: true
            }
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(e.target.value == ''){
                    this.isShowDetail = true
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            sortChange(e){
                if(e.target.value != 'total_amount' || e.target.value != 'qty'){
                    this.inputShowTop = 0
                }
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            async handleInputLocationChange(newVal, oldVal) {
                if (!newVal || newVal.length === 0) {
                    var userId = secureStorage.getItem("userId");
                    var sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                    this.siteOptions = sites;
                    this.sort(this.siteOptions);
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
                    let siteId = secureStorage.getItem("defaultSiteId");
                    this.inputSite = [siteId]
                }
            },
            generateReport: async function () {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,
                    "isShow": this.isShowDetail,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "top": this.inputShowTop,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'item_returns?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                var siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    var paperSize = 'legal'

                    if(this.isShowTotalAmountWithoutTax){
                        paperSize = [612.5815, 1081.3442]
                    }

                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: paperSize });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];
                    if(this.isShowDetail == true){
                        headers = [
                            [
                                {content: '#', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Prod. Code', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Barcode', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Description', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Retail Price', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Qty', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Avg Price', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Total Amount', styles: {halign: 'center', valign: 'center'}},
                            ]
                        ]
                    } else {
                        headers = [
                            [
                                '',
                                {content: 'Qty', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Total Amount', styles: {halign: 'center', valign: 'center'}}
                            ]
                        ]
                    }

                    if(this.isShowTotalAmountWithoutTax){
                        headers[0].push({content: 'Total Amount w/o Tax', styles: {halign: 'center', valign: 'top'}})
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let total_qty = 0
                        let total_total_amount = 0
                        let total_amount_without_tax = 0
                        let grand_qty = 0
                        let grand_total_amount = 0
                        let grand_total_amount_without_tax = 0

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        let grouper = 'start'
                        let type_header = 'start'

                        if(this.birSalesReports.length > 0){
                            let monthly_grouper_arr = []
                            let arr = 'start'

                            if(this.inputGroupBy == 'monthly' && this.isShowDetail == true){
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]

                                    if(i == this.birSalesReports.length-1){
                                        if(arr == 'start'){
                                            monthly_grouper_arr.push({
                                                key: reportLine.grouper_id,
                                                value: reportLine.grouper_name
                                            });
                                        } else {
                                            if(arr.key == reportLine.grouper_id){

                                                //replace value then push
                                                if(arr.value > reportLine.grouper_name){
                                                    arr.value = reportLine.grouper_name
                                                }

                                                monthly_grouper_arr.push(arr)
                                            } else {
                                                //push prev arr
                                                monthly_grouper_arr.push(arr)

                                                //push current arr
                                                monthly_grouper_arr.push({
                                                    key: reportLine.grouper_id,
                                                    value: reportLine.grouper_name
                                                });
                                            }
                                        }
                                    } else {
                                        if(arr == 'start'){
                                            arr = {
                                                key: reportLine.grouper_id,
                                                value: reportLine.grouper_name
                                            }
                                        } else {
                                            if(arr.key == reportLine.grouper_id){
                                                //replace value
                                                if(arr.value > reportLine.grouper_name){
                                                    arr.value = reportLine.grouper_name
                                                }

                                            } else {
                                                //push prev arr
                                                monthly_grouper_arr.push(arr)

                                                //replace current arr
                                                arr = {
                                                    key: reportLine.grouper_id,
                                                    value: reportLine.grouper_name
                                                };
                                            }
                                        }
                                    }
                                }
                            }

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                let grouper_name = reportLine.grouper_name
                                if(this.inputGroupBy == 'daily'){
                                    grouper_name = moment(reportLine.grouper_name).format('YYYY/MM/DD')
                                } else if(this.inputGroupBy == 'monthly' && this.isShowDetail == true){
                                    let vdate = monthly_grouper_arr.find(x => x.key === reportLine.grouper_id).value
                                    grouper_name = moment(vdate).format('(YYYY) DD - MMMM')
                                } else if(this.inputGroupBy == 'monthly' && this.isShowDetail == false){
                                    grouper_name = moment(reportLine.grouper_name).format('(YYYY) DD - MMMM')
                                }

                                if(this.inputGroupBy == 'supplier_type_id'){
                                    if(type_header == 'start'){
                                        let type_header = [{content: reportLine.header_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}]
                                        reportData.push(Object.assign({}, type_header))
                                    } else {
                                        if(type_header != reportLine.header_id){
                                            let type_header = [{content: reportLine.header_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}]
                                            reportData.push(Object.assign({}, type_header))
                                        }
                                    }
                                    type_header = reportLine.header_id
                                }

                                if(this.inputGroupBy != ''){
                                    if(this.isShowDetail == true){
                                        if(grouper == 'start'){
                                            let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                            reportData.push(Object.assign({}, detail_header))
                                        } else {
                                            if(grouper != reportLine.grouper_id){
                                                let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                                reportData.push(Object.assign({}, detail_header))
                                            }
                                        }
                                        grouper = reportLine.grouper_id
                                    }
                                }

                                let detail = []
                                if(this.isShowDetail == true){
                                    detail = [
                                        i+1,
                                        reportLine.product_code,
                                        reportLine.barcode,
                                        reportLine.description,
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.retail_price)), 'Y'),
                                        this.convertToCurrency(Number(reportLine.qty)),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.avg_price)), 'Y'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.total_amount)), 'Y')
                                    ]
                                } else {
                                    detail = [
                                        grouper_name,
                                        this.convertToCurrency(Number(reportLine.qty)),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.total_amount)), 'Y')
                                    ]
                                }
                                
                                if(this.isShowTotalAmountWithoutTax){
                                    detail.push(this.addMaskValidation(reportLine.total_amount_without_tax, 'Y'))
                                }


                                reportData.push(Object.assign({}, detail))

                                total_qty += Number(reportLine.qty)
                                total_total_amount += Number(reportLine.total_amount)
                                if(this.isShowTotalAmountWithoutTax){
                                    total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                                }
                                grand_qty += Number(reportLine.qty)
                                grand_total_amount += Number(reportLine.total_amount)
                                if(this.isShowTotalAmountWithoutTax){
                                    grand_total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                                }

                                if(i == this.birSalesReports.length-1){
                                    if(this.inputGroupBy != ''){
                                        let sub_detail = []
                                        if(this.isShowDetail == true){
                                            let spacer = grouper_name
                                            if(this.inputGroupBy == 'supplier_type_id'){
                                                spacer = reportLine.header_name
                                            }

                                            if(this.isShowTotalAmountWithoutTax){
                                                sub_detail = ["", "", "",
                                                        {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                                                        this.convertToCurrency(total_qty), '',
                                                        this.addMaskValidation(this.convertToCurrency(total_total_amount), 'Y'),
                                                        this.addMaskValidation(this.convertToCurrency(total_amount_without_tax), 'Y')
                                                    ]
                                            }else{
                                                    sub_detail = ["", "", "",
                                                        {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                                                        this.convertToCurrency(total_qty), '',
                                                        this.addMaskValidation(this.convertToCurrency(total_total_amount), 'Y')
                                                    ]
                                            }
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, sub_detail))
                                        }
                                    }

                                    reportData.push(Object.assign({}, ["rowLine"]))

                                    if(this.isShowDetail == true){
                                        if(this.isShowTotalAmountWithoutTax){
                                            reportData.push(Object.assign({}, ['', '', '', 'Grand Total :', '',
                                                this.convertToCurrency(grand_qty), '',
                                                this.addMaskValidation(this.convertToCurrency(grand_total_amount), 'Y'),
                                                this.addMaskValidation(this.convertToCurrency(grand_total_amount_without_tax), 'Y')
                                            ]));
                                        }else{
                                            reportData.push(Object.assign({}, ['', '', '', 'Grand Total :', '',
                                                this.convertToCurrency(grand_qty), '',
                                                this.addMaskValidation(this.convertToCurrency(grand_total_amount), 'Y')
                                            ]));
                                        }
                                    } else {
                                        reportData.push(Object.assign({}, ['Grand Total :',
                                            this.convertToCurrency(grand_qty),
                                            this.addMaskValidation(this.convertToCurrency(grand_total_amount), 'Y')
                                        ]));
                                    }
                                } else {
                                    if(this.isShowDetail == true){
                                        let current_grouper = ""
                                        let next_grouper = ""

                                        if(this.inputGroupBy == 'supplier_type_id'){
                                            current_grouper = reportLine.header_id
                                            next_grouper = this.birSalesReports[i+1].header_id
                                        } else {
                                            current_grouper = reportLine.grouper_id
                                            next_grouper = this.birSalesReports[i+1].grouper_id
                                        }

                                        if(current_grouper != next_grouper){
                                            if(this.inputGroupBy != ''){
                                                reportData.push(Object.assign({}, ["rowLine"]))
                                                let sub_detail = []

                                                let spacer = grouper_name
                                                if(this.inputGroupBy == 'supplier_type_id'){
                                                    spacer = reportLine.header_name
                                                }

                                                if(this.isShowDetail == true){
                                                    if(this.isShowTotalAmountWithoutTax){
                                                        sub_detail = ["", "", "",
                                                            {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                                                            this.convertToCurrency(total_qty), '',
                                                            this.addMaskValidation(this.convertToCurrency(total_total_amount), 'Y'),
                                                            this.addMaskValidation(this.convertToCurrency(total_amount_without_tax), 'Y')
                                                        ]
                                                    }else{
                                                        sub_detail = ["", "", "",
                                                            {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                                                            this.convertToCurrency(total_qty), '',
                                                            this.addMaskValidation(this.convertToCurrency(total_total_amount), 'Y')
                                                        ]
                                                    }
                                                } else {
                                                    sub_detail = [{content: spacer, styles: {halign: 'right', fontStyle: 'bold'}},
                                                        this.convertToCurrency(total_qty),
                                                        this.addMaskValidation(this.convertToCurrency(total_total_amount), 'Y')
                                                    ]
                                                }
                                                reportData.push(Object.assign({}, sub_detail))

                                                total_qty = 0
                                                total_total_amount = 0
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Item Returns Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        if(this.isSeparateSite == true){
                            doc.text(340,20,siteSpecific[x].report_details[0].site_name,"right");
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(340,20,site_text,"right");
                        }
                        doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                        let splitTitle = doc.splitTextToSize("Filtered by: " + status_header + filter_header, 180);
                        doc.text(15,30,splitTitle);

                        let colStyles = {}

                        if(this.isShowDetail == true){
                            colStyles = {
                                0: {cellWidth: 10},
                                1: {cellWidth: 35},
                                2: {cellWidth: 40},
                                3: {cellWidth: 80},
                                4: {cellWidth: 40},
                                5: {cellWidth: 40},
                                6: {cellWidth: 35},
                                7: {cellWidth: 35},
                                8: {cellWidth: 35}
                            }
                        } else {
                            colStyles = {
                                0: {cellWidth: 205},
                                1: {cellWidth: 60},
                                2: {cellWidth: 60}
                            }
                        }

                        doc.autoTable({
                            startY: 45,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: {bottom: 30},
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        
                        let pageCount = doc.internal.getNumberOfPages();

                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Item Returns Report" + group_text, 340, 200, i, pageCount)
                        }

                        
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Item_Returns_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
            this.spinning = false;
            },
            generateFile: async function() {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,
                    "isShow": this.isShowDetail,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "top": this.inputShowTop,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'item_returns?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let headers = ["#", "Product Code", "Barcode", "Description", "Retail Price", "Average Price", "Quantity", "Total Amount"];
                    if(this.isShowTotalAmountWithoutTax){
                        headers.push("Total Amount w/o Tax")
                    }

                    let site_specific = [];

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let total_qty = 0
                            let total_amount_without_tax = 0
                            let total_total_amount = 0

                            let grand_qty = 0
                            let grand_total_amount_without_tax = 0
                            let grand_total_amount = 0

                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let detail = []
                                detail = [
                                    i+1,
                                    reportLine.product_code,
                                    reportLine.barcode,
                                    reportLine.description,
                                    this.addMaskValidation(reportLine.retail_price, 'Y'),
                                    this.addMaskValidation(reportLine.avg_price, 'Y'),
                                    this.convertToCurrency(Number(reportLine.qty)),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.total_amount)), 'Y')
                                ]
                                if(this.isShowTotalAmountWithoutTax){
                                    detail.push(this.addMaskValidation(this.convertToCurrency(Number(reportLine.total_amount_without_tax)), 'Y'))
                                }

                                total_qty += Number(reportLine.qty)
                                total_total_amount += Number(reportLine.total_amount)
                                
                                grand_qty += Number(reportLine.qty)
                                grand_total_amount += Number(reportLine.total_amount)
                                if(this.isShowTotalAmountWithoutTax){
                                    total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                                    grand_total_amount_without_tax += Number(reportLine.total_amount_without_tax)
                                }

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    //Grand Total
                                    
                                    let grand_detail = ['','','','Grand Total :','','',
                                        this.convertToCurrency(grand_qty),
                                        this.addMaskValidation(this.convertToCurrency(grand_total_amount), 'Y')
                                    ]
                                    if(this.isShowTotalAmountWithoutTax){
                                        grand_detail.push(grand_total_amount_without_tax)
                                    }
                                    reportData.push(Object.assign({}, grand_detail));

                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        sub_detail = ['','','','Sub Total :','','',
                                            this.convertToCurrency(total_qty),
                                            this.addMaskValidation(this.convertToCurrency(total_total_amount), 'Y')
                                        ]

                                        if(this.isShowTotalAmountWithoutTax){
                                            sub_detail.push(total_amount_without_tax)
                                        }

                                        reportData.push(Object.assign({}, sub_detail))

                                        total_qty = 0
                                        total_total_amount = 0
                                    }
                                }
                            }

                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }

                        if(this.isSeparateSite == true){
                            reportData.unshift([siteSpecific[x].report_details[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                        }
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Item Returns Report" + group_text, "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                }
                this.spinning = false
            },
            clearJsonData(){
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>
